import { Component } from "react";
import LoginHeaderOperational from './LoginHeaderOperational';
import Sidebar_Progress from "../layouts/Operational_Sidebar_Progress.component";
import { API_URL } from "../../constant/API_Settings";
import React, { useMemo, useState } from 'react';
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import logo from '../../img/logo.svg';
import { FuelLabel } from '../../utils/fuelLabelColor';
import { buildSummaryPayloadFromDetailed } from '../../utils/dailyTransactionSummaryRows';
import { buildPackedOilSalesTableRows } from '../../utils/dailyTransactionPackedOilSalesRows';
import {
  buildCylinderSalesTableRows,
  buildOilBarrelSalesTableRows,
  buildDigitalPaymentTableRows,
  formatShortExcessLabel,
} from '../../utils/dailyTransactionSectionRows';
import { NumTd } from '../../utils/reportDisplay';
import { ReportDateRangeFields } from './other-reports/OtherReportShared';
import './daily-transaction-sheet.css';
import '../operational-model/other-reports/other-reports.css';
import '../operational-model/other-reports/report-table.css';

const DailyTransactionSummary = (props) => {





  const [inputValues, setInputValues] = useState({})
  const [pump, setPump] = useState({})
  const [input, setInput] = useState({})

  const [fule_sale_summary, setFuleSaleSummary] = useState([])
  const [fule_sale_sum_summary, setFuleSaleSumSummary] = useState([])
  const [fuel_recoup_sum_summary, setFuelRecoupSumSummary] = useState(0)
  const [fuel_actual_sum_summary, setFuelActualSumSummary] = useState(0)
  const [fule_sale_summary_outstanding, setFuleSaleSummaryOutstanding] = useState([])

  const [Loose_oil_summary, setLooseOilSummary] = useState([])
  const [Loose_oil_sum_summary, setLooseOilSumSummary] = useState([])
  const [Loose_oil_summary_outstanding, setLooseOilSummaryOutstanding] = useState([])

  const [paked_oil_detailed, setPakedOilDetailed] = useState([])
  const [paked_oil_sum, setPakedOilSumSummary] = useState([])
  const [paked_oil_outstanding, setPakedOilSummaryOutstanding] = useState([])

  const [cylinder_sales, setCylinderSales] = useState([])
  const [cylinder_sales_sum, setCylinderSalesSum] = useState(0)
  const [cylinder_sales_outstanding, setCylinderSalesOutstanding] = useState(0)

  const [los_sales, setLosSales] = useState([])
  const [los_sales_sum, setLosSalesSum] = useState(0)
  const [los_sales_outstanding, setLosSalesOutstanding] = useState(0)

  const [reciept_summary, setRecieptSummary] = useState([])
  const [receipt_sum_summary, setReceiptSumSummary] = useState([])
  const [reciept_summary_outstanding, setRecieptSummaryOutstanding] = useState([])


  const [other_income_summary, setOtherIncomeSummary] = useState([])
  const [other_income_sum_summary, setOtherIncomeSumSummary] = useState([])
  const [other_income_summary_outstanding, setOtherIncomeSummaryOutstanding] = useState([])

  const [credit_sales_summary, setCreditsalesSummary] = useState([])
  const [credit_sales_sum_summary, setCreditSalesSumSummary] = useState([])
  const [credit_sales_summary_outstanding, setCreditsalesSummaryOutstanding] = useState([])

  const [recoup_summary, setRecoupSummary] = useState([])
  const [recoup_sum_summary, setRecoupSumSummary] = useState([])
  const [recoup_summary_outstanding, setRecoupSummaryOutstanding] = useState([])

  const [mla_sales_summary, setMLASalesSummary] = useState([])
  const [mla_sales_sum_summary, setMLASalesSumSummary] = useState([])
  const [mla_sales_summary_outstanding, setMLASalesSummaryOutstanding] = useState([])

  const [fleet_sales_summary, setFleetalesSummary] = useState([])
  const [fleet_sales_sum_summary, setFleetSalesSumSummary] = useState([])
  const [fleet_sales_summary_outstanding, setFleetalesSummaryOutstanding] = useState([])

  const [expense_voucher_summary, setExpenseVoucherSummary] = useState([])
  const [expense_voucher_sum_summary, setExpenseVoucherSumSummary] = useState([])
  const [expense_voucher_summary_outstanding, setExpenseVoucherSummaryOutstanding] = useState([])

  const [payment_voucher_summary, setPaymentVoucherSummary] = useState([])
  const [payment_voucher_sum_summary, setPaymentVoucherSumSummary] = useState([])
  const [payment_voucher_summary_outstanding, setPaymentVoucherSummaryOutstanding] = useState([])

  const [reciept_voucher_summary, setRecieptVoucherSummary] = useState([])
  const [reciept_voucher_sum_summary, setRecieptVoucherSumSummary] = useState([])
  const [reciept_voucher_summary_outstanding, setRecieptVoucherSummaryOutstanding] = useState([])

  const [digital_payment_summary, setDigitalPaymentSummary] = useState([])
  const [digital_payment_sum_summary, setDigitalPaymentSumSummary] = useState([])
  const [digital_payment_summary_outstanding, setDigitalPaymentSummaryOutstanding] = useState([])


  const [non_fuel_purchase_summary, setNonFuelPurchaseSummary] = useState([])
  const [non_fuel_purchase_sum_summary, setNonFuelPurchaseSumSummary] = useState([])
  const [non_fuel_purchase_discount_sum, setNonFuelPurchaseDiscountSum] = useState(0)
  const [non_fuel_purchase_summary_outstanding, setNonFuelPurchaseSummaryOutstanding] = useState([])

  const [cylinder_purchase, setCylinderPurchase] = useState([])
  const [cylinder_purchase_sum, setCylinderPurchaseSum] = useState(0)
  const [cylinder_purchase_outstanding, setCylinderPurchaseOutstanding] = useState(0)


  const [short_excess_summary, setShortExcessSummary] = useState([])
  const [short_excess_sum_summary, setShortExcessSumSummary] = useState([])
  const [short_excess_summary_outstanding, setShortExcessSummaryOutstanding] = useState([])

  const [bank_transcation_summary, setBankTranscationSummary] = useState([])
  const [bank_transcation_sum_summary, setBankTranscationSumSummary] = useState([])
  const [bank_transcation_summary_outstanding, setBankTranscationSummaryOutstanding] = useState([])


  const [fuel_purchase_summary, setFuelPurchaseSummary] = useState([])
  const [fuel_purchase_summary_sum, setFuelPurchaseSumSummary] = useState([])
  const [fuel_purchase_summary_outstanding, setFuelPurchaseSummaryOutstanding] = useState([])

  const [closing_cash, setClosing] = useState([])
  const [closing_cash_dr_cr, setClosingDrCr] = useState({})
  const [opening_balance, setOpeningBalance] = useState([])
  const [opening_balance_dr_cr, setOpeningBalanceDrCr] = useState({})
  const [exportingPdf, setExportingPdf] = useState(false)


  const history = useHistory()
  const [state, setState] = useState([])
  const [all, setAll] = useState([])
  var buffer = ''; var flag = 0;

  useEffect(() => {


  }, [])
  const handleInput = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = (event) => {
    getDailySheetSummary()
  }



  async function getDailySheetSummary() {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal('Please select start and end dates', '', 'warning');
      return;
    }

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
      body: JSON.stringify({
        from_date: inputValues.start_date,
        to_date: inputValues.end_date,
        summary: 1
      })
    };
    fetch(API_URL + "/get_daily_transaction", requestOptions)
      .then(async (response) => {
        const responseData = await response.json();
        if (!response.ok || responseData.status === false) {
          throw new Error(responseData.message || 'Unable to load daily transaction summary.');
        }
        return responseData;
      })
      .then(responseData => {
        const summaryData = Array.isArray(responseData.fuel_sales_summary)
          ? {
              fuel_sales_summary: responseData.fuel_sales_summary,
              loose_oil_sales_summary: responseData.loose_oil_sales_summary,
              reciept_voucher_summary: responseData.reciept_voucher_summary,
              credit_sales_summary: responseData.credit_sales_summary,
              fleet_card_summary: responseData.fleet_card_summary,
              recoup_summary: responseData.recoup_summary,
              mla_coupon_summary: responseData.mla_coupon_summary,
              expense_voucher_summary: responseData.expense_voucher_summary,
              payment_voucher_summary: responseData.payment_voucher_summary,
              digital_payment_summary: responseData.digital_payment_summary,
              non_fuel_purchase_summary: responseData.non_fuel_purchase_summary,
              short_excess_summary: responseData.short_excess_summary,
              other_income_summary: responseData.other_income_summary,
              bank_transaction_summary: responseData.bank_transaction_summary,
              fule_purchase_transactions_summary: responseData.fule_purchase_transactions_summary,
            }
          : buildSummaryPayloadFromDetailed(responseData);

        setFuleSaleSummary(summaryData.fuel_sales_summary)
        setFuleSaleSumSummary(responseData.fuel_sales_summary_sum ?? responseData.total_sales?.fuel_sales_detailed_sum ?? 0)
        setFuelRecoupSumSummary(responseData.total_sales?.fuel_recoup_detailed_sum ?? 0)
        setFuelActualSumSummary(responseData.total_sales?.fuel_actual_detailed_sum ?? 0)
        setFuleSaleSummaryOutstanding(responseData.fuel_sales_outstanding)


        setLooseOilSummary(summaryData.loose_oil_sales_summary)
        setLooseOilSumSummary(responseData.loose_oil_sales_summary_sum ?? responseData.total_sales?.loose_oil_sales_detailed_sum ?? 0)
        setLooseOilSummaryOutstanding(responseData.looseoil_outstanding)


        setPakedOilDetailed(
          (responseData.packed_oil_sales_summary && responseData.packed_oil_sales_summary.length)
            ? responseData.packed_oil_sales_summary
            : (responseData.packed_oil_sales_detailed || [])
        )
        setPakedOilSumSummary(responseData.packed_oil_sales_summary_sum ?? responseData.total_sales?.packed_oil_sales_detailed_sum ?? responseData.packed_oil_sales_detailed_sum ?? 0)
        setPakedOilSummaryOutstanding(responseData.packedoil_outstanding)

        setCylinderSales(responseData.cylindersales_detailed || [])
        setCylinderSalesSum(responseData.total_sales?.cylinder_sales_detailed_sum ?? 0)
        setCylinderSalesOutstanding(responseData.outstanding?.cylinder_outstandings ?? 0)

        setLosSales(responseData.los_detailed || [])
        setLosSalesSum(responseData.total_sales?.twotsales_detailed_sum ?? 0)
        setLosSalesOutstanding(responseData.outstanding?.los_outstandings ?? 0)

        setRecieptSummary(summaryData.reciept_voucher_summary)
        setReceiptSumSummary(responseData.reciept_voucher_summary_sum ?? responseData.reciept_voucher_deailed_sum ?? responseData.total_sales?.reciept_voucher_deailed_sum ?? 0)
        setRecieptSummaryOutstanding(responseData.receipts_outstanding)


        setCreditsalesSummary(summaryData.credit_sales_summary)
        setCreditSalesSumSummary(responseData.credit_sales_summary_sum ?? responseData.credit_sales_detailed_sum ?? responseData.total_sales?.credit_sales_detailed_sum ?? 0)
        setCreditsalesSummaryOutstanding(responseData.credit_sales_outstanding)

        setFleetalesSummary(summaryData.fleet_card_summary)
        setFleetSalesSumSummary(responseData.fleet_card_summary_sum ?? responseData.fleet_card_detailed_sum ?? responseData.total_sales?.fleet_card_detailed_sum ?? 0)
        setFleetalesSummaryOutstanding(responseData.fleet_card_outstanding)

        setRecoupSummary(summaryData.recoup_summary)
        setRecoupSumSummary(responseData.recoup_summary_sum ?? responseData.recoup_detailed_sum ?? responseData.total_sales?.recoup_detailed_sum ?? 0)
        setRecoupSummaryOutstanding(responseData.recoup_outstanding)

        setMLASalesSummary(summaryData.mla_coupon_summary)
        setMLASalesSumSummary(responseData.mla_coupon_summary_sum ?? responseData.mla_coupon_detailed_sum ?? responseData.total_sales?.mla_coupon_detailed_sum ?? 0)
        setMLASalesSummaryOutstanding(responseData.mla_outstanding)

        setExpenseVoucherSummary(summaryData.expense_voucher_summary)
        setExpenseVoucherSumSummary(responseData.expense_voucher_summary_sum ?? responseData.expense_voucher_detailed_sum ?? responseData.total_sales?.expense_voucher_detailed_sum ?? 0)
        setExpenseVoucherSummaryOutstanding(responseData.expense_voucher_outstanding)


        setPaymentVoucherSummary(summaryData.payment_voucher_summary)
        setPaymentVoucherSumSummary(responseData.payment_voucher_summary_sum ?? responseData.payment_voucher_detailed_sum ?? responseData.total_sales?.payment_voucher_detailed_sum ?? 0)
        setPaymentVoucherSummaryOutstanding(responseData.payment_voucher_outstanding)

        setRecieptVoucherSummary(responseData.reciept_voucher_bank_summary)
        setRecieptVoucherSumSummary(responseData.reciept_voucher_bank_summary_sum)
        setRecieptVoucherSummaryOutstanding(responseData.receipts_outstanding)


        setDigitalPaymentSummary(summaryData.digital_payment_summary)
        setDigitalPaymentSumSummary(responseData.digital_payment_summary_sum ?? responseData.digital_payment_detailed_sum ?? responseData.total_sales?.digital_payment_detailed_sum ?? 0)
        setDigitalPaymentSummaryOutstanding(responseData.card_digital_outstanding)



        setNonFuelPurchaseSummary(summaryData.non_fuel_purchase_summary)
        setNonFuelPurchaseSumSummary(responseData.non_fuel_purchase_summary_sum ?? responseData.non_fuel_purchase_detailed_sum ?? responseData.total_sales?.non_fuel_purchase_detailed_sum ?? 0)
        setNonFuelPurchaseDiscountSum(responseData.total_sales?.non_fuel_purchase_discount_sum ?? 0)
        setNonFuelPurchaseSummaryOutstanding(responseData.non_fuel_purchase_outstanding)

        setCylinderPurchase(responseData.cylinderpurchase_detailed || [])
        setCylinderPurchaseSum(responseData.total_sales?.cylinder_purchase_detailed_sum ?? 0)
        setCylinderPurchaseOutstanding(responseData.outstanding?.cyl_purchase_outstanding ?? 0)



        setShortExcessSummary(summaryData.short_excess_summary)
        setShortExcessSumSummary(responseData.short_excess_summary_sum ?? responseData.short_excess_detailed_sum ?? responseData.total_sales?.short_excess_detailed_sum ?? 0)
        setShortExcessSummaryOutstanding(responseData.short_excess_outstanding)

        setOtherIncomeSummary(summaryData.other_income_summary)
        setOtherIncomeSumSummary(responseData.other_income_summary_sum ?? responseData.other_income_detailed_sum ?? responseData.total_sales?.other_income_detailed_sum ?? 0)
        setOtherIncomeSummaryOutstanding(responseData.other_income_outstanding)

        setBankTranscationSummary(summaryData.bank_transaction_summary)
        setBankTranscationSumSummary(responseData.bank_transaction_summary_sum ?? responseData.bank_transaction_detailed_sum ?? responseData.total_sales?.bank_transaction_detailed_sum ?? 0)
        setBankTranscationSummaryOutstanding(responseData.bannk_transaction_outstanding)

        setFuelPurchaseSummary(summaryData.fule_purchase_transactions_summary)
        setFuelPurchaseSumSummary(responseData.fule_purchase_transactions_summary_sum ?? responseData.fule_purchase_transactions_sum ?? responseData.total_sales?.fule_purchase_transactions_sum ?? 0)
        setFuelPurchaseSummaryOutstanding(responseData.fuel_purchase_outstanding)


        setClosing(responseData.closing_cash)
        setClosingDrCr(responseData.closing_cash_dr_cr || {})
        setOpeningBalance(responseData.opening_balance)
        setOpeningBalanceDrCr(responseData.opening_balance_dr_cr || {})


        var pump_name = responseData.pump_data?.[0]?.pump_name
        var pump_address = responseData.pump_data?.[0]?.pump_address
        setPump({
          ...pump,
          pump_name: pump_name,
          pump_address: pump_address

        })

        var start_date = responseData.start_date
        var end_date = responseData.end_date
        console.log(end_date)
        setInput({
          ...input,
          start_date: start_date,
          end_date: end_date

        })

      })
      .catch(e => {
        swal('Daily Transaction Summary', e.message || 'Something went wrong.', 'error');
      });
  }

  function handleChange(e) {
    var value
    if (e.target.value == "detiled") {
      value = 1
    }
    else {
      value = 2
    }
    setInputValues({
      ...inputValues,
      [e.target.name]: value
    });

  }


  async function savesheet() {
    if (!inputValues.start_date || !inputValues.end_date) {
      swal('Please select start and end dates', '', 'warning');
      return;
    }
    setExportingPdf(true);
    try {
      const response = await fetch(API_URL + '/daily_transaction_export_pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
          Accept: 'application/json',
        },
        body: JSON.stringify({
          from_date: inputValues.start_date,
          to_date: inputValues.end_date,
          summary: 1,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status === false) {
        throw new Error(data.message || 'Unable to start PDF export.');
      }
      swal(
        'Export to PDF',
        data.message || 'PDF is generating. Open the download icon in the header when it is ready.',
        'success'
      );
    } catch (error) {
      swal('Export to PDF', error.message || 'Something went wrong.', 'error');
    } finally {
      setExportingPdf(false);
    }
  }

  const packedOilSalesRows = useMemo(
    () => buildPackedOilSalesTableRows(paked_oil_detailed),
    [paked_oil_detailed]
  );
  const cylinderSalesRows = useMemo(
    () => buildCylinderSalesTableRows(cylinder_sales),
    [cylinder_sales]
  );
  const oilBarrelSalesRows = useMemo(
    () => buildOilBarrelSalesTableRows(los_sales),
    [los_sales]
  );
  const digitalPaymentRows = useMemo(
    () => buildDigitalPaymentTableRows(digital_payment_summary),
    [digital_payment_summary]
  );

  return (
    <>

      <div className="main-container page-wrap">
        <div className="d-md-flex">
          <Sidebar_Progress props={props} progress={8} />
          <div className="content-area">
            <LoginHeaderOperational props={props} page_title="  " />

            {

            }

            <div className="container pb-3">
              <div className="row justify-content-center  mt-3 form-container">


                <div className="col-md-12">
                  <div className="row mb-3">

                    <div className="col-md-8 d-flex">
                      <div className="text-start d-flex pe-1 mt-3 other-report-toolbar-dates">
                        <ReportDateRangeFields
                          startDate={inputValues.start_date}
                          endDate={inputValues.end_date}
                          onChange={({ start_date, end_date }) => setInputValues({
                            ...inputValues,
                            start_date,
                            end_date,
                          })}
                        />
                      </div>
                      <div className="text-start d-flex pe-4 mt-5">
                        <div className="form-group">
                          <a className="btn btn-primary mb-md-0  ms-1" onClick={handleSubmit}>Submit </a>
                        </div>
                      </div>


                      <div className="col-md-9">
                        <div className="text-end mt-5"><a className="btn btn-gray px-3 mb-md-0 mb-3 me-3" onClick={(event) => history.push("/daily-transaction-sheet")}>Back </a>
                        </div>
                      </div>
                    </div>


                    <div className="table-widget">
                      <div className="form-wrap balace-sheetwrap mt-3">

                        <div className="row mb-3">
                          <div className="col-md ">
                            <h2 className="table-title  mb-1">{pump.pump_name ? pump.pump_name : "COMPANY NAME"}</h2>
                            <h4 className="table-title mb-1">Daily Transaction Sheet Summary</h4>
                            <h5>  {input.start_date ? <>{input.start_date} -- {input.end_date}</> : "DATE"}</h5>
                            <img src={logo} className="img-fluid float-end " width="100px" />
                          </div>
                        </div>

                        <div className="table-widget">
                          <table className="table border">
                            <thead>
                              <tr class="border">
                                <th>Opening balance</th>
                                <th className="report-amount-header">Debit(RS)</th>
                                <th className="report-amount-header">Credit(RS)</th>
                                <th className="report-amount-header">Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <NumTd value={opening_balance} />
                                <NumTd value={opening_balance_dr_cr?.dr_amount} />
                                <NumTd value={opening_balance_dr_cr?.cr_amount} />
                                <NumTd value={opening_balance_dr_cr?.outstanding ?? opening_balance} />
                              </tr>
                            </tbody>
                          </table>
                        </div>


                        <div className="table-widget daily-transaction-section">
                          <h3 className="table-title text-start">Fuel Sales</h3>
                          <div className="daily-transaction-table-wrap">
                          <table className="daily-transaction-scroll-table table border">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Nozzle Name</th>
                                <th className="report-amount-header">Quantity</th>
                                <th className="report-amount-header">Recoup</th>
                                <th className="report-amount-header">Price</th>
                                <th className="report-amount-header">Debit (Total Sale)</th>
                                <th className="report-amount-header">Credit (Recoup)</th>
                                <th className="report-amount-header">Actual Amount</th>
                                <th className="report-amount-header">Outstanding</th>
                              </tr>
                            </thead>
                            <tbody>
                              {fule_sale_summary.map((obj, index) => {
                                const drAmount = Number(obj.dr_amount ?? obj.amount ?? 0);
                                const recoupAmount = Number(obj.recoup_amount ?? 0);
                                const actualAmount = Number(obj.net_amount ?? (drAmount - recoupAmount));
                                const isRecoupRow = Boolean(obj.is_recoup_row)
                                  || String(obj.nozzle_name || '').toLowerCase() === 'recoup';

                                return (
                                  <tr key={obj.key || `fuel-summary-${index}`}>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <td>{obj.nozzle_name || '—'}</td>
                                    <NumTd value={isRecoupRow ? '' : obj.quantity} />
                                    <NumTd value={obj.recoup_qty || ''} />
                                    <NumTd value={isRecoupRow ? '' : obj.price} />
                                    <NumTd value={isRecoupRow ? '' : drAmount} />
                                    <NumTd value={recoupAmount || ''} />
                                    <NumTd value={actualAmount} />
                                    <NumTd value={obj.outstanding} />
                                  </tr>
                                );
                              })}
                              <tr className="daily-transaction-fuel-subtotal">
                                <td colSpan={2} className="text-end"><b>Total Fuel Sale</b></td>
                                <td />
                                <td />
                                <td />
                                <NumTd value={fule_sale_sum_summary} />
                                <NumTd value={fuel_recoup_sum_summary} />
                                <NumTd value={fuel_actual_sum_summary} />
                                <NumTd value={fule_sale_summary_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                          </div>
                        </div>

                        <div class="table-widget">

                          <h3 className="table-title text-start" >Loose Oil Sales</h3>

                          <table class="table border">

                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>




                              </tr>

                            </thead>
                            <tbody>
                              {
                                Loose_oil_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.product_name}</td>
                                    <NumTd value={obj.quantity} />
                                    <NumTd value={obj.selling_price} />
                                    <td></td>
                                    <NumTd value={obj.dr_amount} />
                                    <NumTd value={obj.cr_amount} />
                                    <td></td>



                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td>Total Loose Oil Sales</td>
                                <NumTd value={Loose_oil_sum_summary} />
                                <td></td>
                                <NumTd value={Loose_oil_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>

                        </div>



                        <div class="table-widget">
                          <h3 className="table-title text-start">Packed Oil and Other Sales</h3>
                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Customer Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Discount(RS)</th>
                                <th>Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {packedOilSalesRows.bodyRows.map((row, index) => {
                                if (row.type === 'subtotal') {
                                  return (
                                    <tr key={`packed-subtotal-${index}`} className="daily-transaction-product-subtotal">
                                      <td></td>
                                      <td>{row.productName} sub Total</td>
                                      <NumTd value={row.quantitySum} />
                                      <td></td>
                                      <NumTd value={row.discountSum} />
                                      <NumTd value={row.debitTotal} />
                                      <NumTd value={row.creditTotal} />
                                      <td></td>
                                    </tr>
                                  );
                                }

                                return (
                                  <tr key={row.key || `packed-row-${index}`}>
                                    <td>{row.productName}</td>
                                    <td>{row.customerName}</td>
                                    <NumTd value={row.quantity} />
                                    <NumTd value={row.sellingPrice} />
                                    <NumTd value={row.discountAmount || ''} />
                                    <NumTd value={row.debitAmount} />
                                    <NumTd value={row.creditAmount} />
                                    <td></td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td colSpan="3"></td>
                                <td>Total Packed Oil and Other Sales</td>
                                <td></td>
                                <NumTd value={paked_oil_sum} />
                                <td></td>
                                <NumTd value={paked_oil_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="table-widget">
                          <h3 className="table-title text-start">Cylinder Sales</h3>
                          <table className="table border">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Customer Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cylinderSalesRows.bodyRows.map((row, index) => {
                                if (row.type === 'subtotal') {
                                  return (
                                    <tr key={`cyl-subtotal-${index}`} className="daily-transaction-product-subtotal">
                                      <td></td>
                                      <td></td>
                                      <td>{row.groupLabel} sub Total</td>
                                      <NumTd value={row.amountSum} />
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  );
                                }

                                return (
                                  <tr key={row.key || `cyl-row-${index}`}>
                                    <td>{row.productName}</td>
                                    <td>{row.customerName}</td>
                                    <NumTd value={row.qty} />
                                    <NumTd value={row.salesPrice} />
                                    <NumTd value={row.debitAmount} />
                                    <NumTd value={row.creditAmount} />
                                    <td></td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td colSpan="2"></td>
                                <td>Total Cylinder Sales</td>
                                <td></td>
                                <td></td>
                                <NumTd value={cylinder_sales_sum} />
                                <NumTd value={cylinder_sales_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="table-widget">
                          <h3 className="table-title text-start">Oil Barrel Sales</h3>
                          <table className="table border">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Customer Name</th>
                                <th>Full Barrel Qty</th>
                                <th>Loose Barrel Qty</th>
                                <th>Full Barrel MRP</th>
                                <th>Loose Barrel MRP</th>
                                <th>Machine sales</th>
                                <th>Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {oilBarrelSalesRows.bodyRows.map((row, index) => {
                                if (row.type === 'subtotal') {
                                  return (
                                    <tr key={`los-subtotal-${index}`} className="daily-transaction-product-subtotal">
                                      <td colSpan="6"></td>
                                      <td>{row.groupLabel} sub Total</td>
                                      <NumTd value={row.amountSum} />
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  );
                                }

                                return (
                                  <tr key={row.key || `los-row-${index}`}>
                                    <td>{row.productName}</td>
                                    <td>{row.customerName}</td>
                                    <NumTd value={row.fullBarrelQty} />
                                    <NumTd value={row.looseBarrelQty} />
                                    <NumTd value={row.fullBarrelMrp} />
                                    <NumTd value={row.looseBarrelMrp} />
                                    <NumTd value={row.machineSales} />
                                    <NumTd value={row.debitAmount} />
                                    <NumTd value={row.creditAmount} />
                                    <td></td>
                                  </tr>
                                );
                              })}
                              <tr>
                                <td colSpan="7"></td>
                                <td>Total Oil Barrel Sales</td>
                                <NumTd value={los_sales_sum} />
                                <NumTd value={los_sales_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="table-widget">


                          <h3 className="table-title text-start" >Receipts </h3>


                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Party Name </th>
                                <th>A/C Category</th>
                                <th>A/C  Sub Category</th>
                                <th>Description</th>

                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                reciept_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.name}</td>
                                    <td>{obj.category}</td>
                                    <td>{obj.ac_name_slug}</td>
                                    <td>{obj.note}</td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>
                                    <td></td>


                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total Receipts </td>
                                <NumTd value={receipt_sum_summary} />
                                <td></td>
                                <NumTd value={reciept_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>

                        </div>


                        <div class="table-widget">
                          <h3 className="table-title text-start" >Other Income</h3>
                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Income Sub Head</th>
                                <th>Discription</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                other_income_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.ac_name_slug}</td>
                                    <td>{obj.note}</td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>
                                    <td></td>



                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>

                                <td>Total Other Income</td>
                                <NumTd value={other_income_sum_summary} />
                                <td></td>
                                <NumTd value={other_income_summary_outstanding} />

                              </tr>

                            </tbody>
                          </table>
                        </div>



                        <div class="table-widget">
                          <h3 className="table-title text-start" >Credit Sales </h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Party Name </th>
                                <th> Product </th>
                                <th> Quantity</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>



                              </tr>

                            </thead>
                            <tbody>
                              {
                                credit_sales_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.name}</td>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <NumTd value={obj.quantity} />
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>






                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td>Total Credit Sales</td>
                                <NumTd value={credit_sales_sum_summary} />
                                <td></td>
                                <NumTd value={credit_sales_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>
                        </div>
                        <div class="table-widget">
                          <h3 className="table-title text-start">Recoup</h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Product Name </th>
                                <th>Recoup Tank</th>
                                <th>Quantity</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                recoup_summary.map((obj) => (

                                  <tr>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <td>{obj.tank_name}</td>

                                    <NumTd value={obj.quantity} />
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>


                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td class="table-footer">Total Recoup </td>
                                <NumTd value={recoup_sum_summary} />
                                <td></td>
                                <NumTd value={recoup_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>
                        </div>

                        <div class="table-widget">

                          <h3 className="table-title text-start" >MLA Coupon </h3>

                          <table class="border table">
                            <thead>
                              <tr>

                                <th>Coupon Number</th>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                mla_sales_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.coupon_no}</td>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <NumTd value={obj.quantity} />
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>


                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td>Total MLA Coupon </td>
                                <NumTd value={mla_sales_sum_summary} />
                                <td></td>
                                <NumTd value={mla_sales_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>

                        </div>
                        <div class="table-widget">

                          <h3 className="table-title text-start" >Fleet card sales </h3>

                          <table class="border table">
                            <thead>
                              <tr>
                                <th>Card Number</th>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                fleet_sales_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.card_no}</td>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <NumTd value={obj.quantity} />
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>

                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td>Total fleet card sales </td>
                                <NumTd value={fleet_sales_sum_summary} />
                                <td></td>
                                <NumTd value={fleet_sales_summary_outstanding} />


                              </tr>

                            </tbody>

                          </table>

                        </div>

                        <div class="table-widget">

                          <h3 className="table-title text-start" >Expense Voucher</h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Party Name</th>
                                <th>Expense category</th>
                                <th>Expense Sub category</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>



                              </tr>

                            </thead>
                            <tbody>
                              {
                                expense_voucher_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.party_name || obj.name || obj.ac_name_slug}</td>
                                    <td>{obj.category}</td>
                                    <td>{obj.sub_category}</td>
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>








                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td>Total Expense Voucher </td>
                                <NumTd value={expense_voucher_sum_summary} />
                                <td></td>
                                <NumTd value={expense_voucher_summary_outstanding} />


                              </tr>

                            </tbody>


                          </table>

                        </div>

                        <div class="table-widget">

                          <h3 className="table-title text-start" >Payment Voucher</h3>
                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Party Name</th>
                                <th>Ac/ Category</th>
                                <th>Ac / Sub Category</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>




                              </tr>

                            </thead>
                            <tbody>
                              {
                                payment_voucher_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.name}</td>
                                    <td>{obj.ac_name_slug}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <NumTd value={obj.amount} />
                                    <td></td>





                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>

                                <td> Total Payment Voucher </td>
                                <NumTd value={payment_voucher_sum_summary} />
                                <td></td>
                                <NumTd value={payment_voucher_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table></div>
                        {/* <h3 className="table-title text-start" >Receipt Voucher</h3>
                                                
                                                                                        <thead>
                                                                                            <tr>
                                                                                              <th>Party  Name</th>
                                                                                              <th>A/C Category</th>
                                                                                              <th>Ac/Sub Category</th>
                                                                                              <th>Descriptinon</th>
                                                                                              <th></th>
                                                                                              <th></th>
                                                                                              <th></th>
                                                                                              <th></th>
                                                                                              
                                                                                            
                                                                                              
                                                                                            </tr>
                                                                                          
                                                                                        </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                      reciept_voucher_summary.map((obj) => (
                                                                                            
                                                                                            <tr>
                                                                                              <td>{obj.name}</td>
                                                                                              <td>{obj.bank_name}</td>
                                                                                              <td>{obj.ac_name_slug}</td>
                                                                                              <td>{obj.note}</td>
                                                                                              <NumTd value={obj.amount} />
                                                                                            </tr>
                                  
                                                                                          ))}
                                                                                          <tr>
                                                                                            <td></td>
                                                                                            <td></td>
                                                                                            <td></td>
                                                                                            <td></td>
                                                                                        <td> Total Payment Voucher </td>
                                                                                        <td>{reciept_voucher_sum_summary}</td>
                                                                                        <td></td>
                                                                                       
                                                                                        </tr>
                                                                                        
                                                                                    </tbody>
                                                 
                                               */}

                        <div class="table-widget">



                          <h3 className="table-title text-start" >Card/Digital Payment</h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Payment Type</th>
                                <th>Bank Name</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>

                            </thead>
                            <tbody>
                              {digitalPaymentRows.bodyRows.map((row, index) => {
                                if (row.type === 'subtotal') {
                                  return (
                                    <tr key={`digital-subtotal-${index}`} className="daily-transaction-product-subtotal">
                                      <td colSpan="3">{row.groupLabel} sub Total</td>
                                      <td></td>
                                      <td></td>
                                      <NumTd value={row.amountSum} />
                                    </tr>
                                  );
                                }

                                return (
                                  <tr key={row.key || `digital-row-${index}`}>
                                    <td>{row.methodName}</td>
                                    <td>{row.bankName}</td>
                                    <td></td>
                                    <td></td>
                                    <NumTd value={row.creditAmount} />
                                    <td></td>
                                  </tr>
                                );
                              })}
                              <tr className="daily-transaction-product-subtotal">
                                <td colSpan="3">Total Card/Digital Payment</td>
                                <td></td>
                                <td></td>
                                <NumTd value={digital_payment_sum_summary} />
                              </tr>

                            </tbody>

                          </table>

                        </div>
                        <div class="table-widget">


                          <h3 className="table-title text-start" >Short/Excess</h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Account Name</th>
                                <th>Short/Excess</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>




                              </tr>

                            </thead>
                            <tbody>
                              {
                                short_excess_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.name}</td>
                                    <td>{formatShortExcessLabel(obj)}</td>
                                    <td></td>
                                    <NumTd value={obj.dr_amount} />
                                    <NumTd value={obj.cr_amount} />
                                    <td></td>


                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>

                                <td>Total Short/Excess </td>
                                <NumTd value={short_excess_sum_summary} />
                                <td></td>
                                <NumTd value={short_excess_summary_outstanding} />

                              </tr>

                            </tbody>

                          </table>
                        </div>
                        <div class="table-widget">

                          <h3 className="table-title text-start" >Bank Transactions</h3>

                          <table class="table border">
                            <thead>
                              <tr>
                                <th>Transcation Type</th>
                                <th>Party Name</th>
                                <th></th>
                                <th >Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>

                              </tr>

                            </thead>
                            <tbody>
                              {
                                bank_transcation_summary.map((obj) => (

                                  <tr>
                                    <td>{obj.transaction_type}</td>
                                    <td>{obj.partyorreference}</td>
                                    <td></td>
                                    <NumTd value={obj.dr_amount} />
                                    <NumTd value={obj.cr_amount} />
                                    <td></td>

                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>


                                <td>Total  Bank Transactions </td>
                                <NumTd value={bank_transcation_sum_summary} />
                                <td></td>
                                <NumTd value={bank_transcation_summary_outstanding} />

                              </tr>

                            </tbody>
                          </table>

                        </div>

                        <div class="table-widget">
                          <h3 className="table-title text-start">Non Fuel Purchase Transaction</h3>
                          <table class="border table">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Invoice Number</th>
                                <th>Vendor Name</th>
                                <th>Discount(RS)</th>
                                <th>Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {non_fuel_purchase_summary.map((obj, index) => (
                                <tr key={`nf-purchase-${index}`}>
                                  <td>{obj.product_name}</td>
                                  <NumTd value={obj.quantity} />
                                  <td>{obj.invoice_number}</td>
                                  <td>{obj.vendor_name || obj.name}</td>
                                  <NumTd value={obj.discount || ''} />
                                  <NumTd value={obj.dr_amount || ''} />
                                  <NumTd value={obj.cr_amount || obj.amount} />
                                  <td></td>
                                </tr>
                              ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total Non - Fuel Purchases</td>
                                <NumTd value={non_fuel_purchase_discount_sum} />
                                <td></td>
                                <NumTd value={non_fuel_purchase_sum_summary} />
                                <NumTd value={non_fuel_purchase_summary_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="table-widget">
                          <h3 className="table-title text-start">Cylinder Purchase Transaction</h3>
                          <table className="table border">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Invoice Number</th>
                                <th>Vendor Name</th>
                                <th>Customer Name</th>
                                <th>Debit(RS)</th>
                                <th>Credit(RS)</th>
                                <th>Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cylinder_purchase.map((obj, index) => (
                                <tr key={`cylp-${index}`}>
                                  <td>{obj.product_name}</td>
                                  <NumTd value={obj.quantity} />
                                  <td>{obj.invoice_number}</td>
                                  <td>{obj.name}</td>
                                  <td>{obj.cust_name}</td>
                                  <td></td>
                                  <NumTd value={obj.amount} />
                                  <td></td>
                                </tr>
                              ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total Cylinder Purchases</td>
                                <td></td>
                                <NumTd value={cylinder_purchase_sum} />
                                <NumTd value={cylinder_purchase_outstanding} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="table-widget">
                          <table className="table border">
                            <thead>
                              <tr class="border">
                                <th>Closing Cash</th>
                                <th className="report-amount-header">Debit(RS)</th>
                                <th className="report-amount-header">Credit(RS)</th>
                                <th className="report-amount-header">Outstanding(RS)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <NumTd value={closing_cash} />
                                <NumTd value={closing_cash_dr_cr?.dr_amount} />
                                <NumTd value={closing_cash_dr_cr?.cr_amount} />
                                <NumTd value={closing_cash_dr_cr?.outstanding ?? closing_cash} />
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <h3 className="table-title text-start">Other Information</h3>

                        <div class="table-widget">
                          <h3 className="table-title text-start" >Fuel Purchase Transaction</h3>

                          <table class="border table">
                            <thead>
                              <tr>
                                <th>Product Name</th>
                                <th>Vendor Name</th>
                                <th>Quantity</th>
                                <th>Invoice Number</th>
                                <th>Amount</th>
                                <th></th>
                                <th></th>
                                {/* <th >Debit(RS)</th>
                                                                                                                    <th>Credit(RS)</th>
                                                                                                                    <th>Outstanding(RS)</th> */}
                              </tr>

                            </thead>
                            <tbody>
                              {
                                fuel_purchase_summary.map((obj) => (

                                  <tr>
                                    <td><FuelLabel name={obj.fuel_name} /></td>
                                    <td>{obj.dealer_name}</td>
                                    <NumTd value={obj.quantity} />
                                    <td>{obj.invoice_no}</td>
                                    <NumTd value={obj.amount} />
                                    <td></td>
                                    <td></td>
                                    {/* <td></td>
                                                                                                            <td></td> */}
                                  </tr>

                                ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Total Fuel Sale </td>
                                <NumTd value={fuel_purchase_summary_sum} />
                                {/* <td></td> */}
                                {/* <td></td> */}

                              </tr>

                            </tbody>
                          </table>
                        </div>

                      </div>



                    </div>
                  </div>


                  <div className="col-md">
                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="btn btn-success px-3 mb-md-0 mb-3 me-3"
                        onClick={savesheet}
                        disabled={exportingPdf || !inputValues.start_date || !inputValues.end_date}
                      >
                        {exportingPdf ? 'Exporting…' : 'Export PDF'}
                      </button>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>

        </div>

      </div>







    </>
  )
}


export default DailyTransactionSummary